import "./BillingWrapper.scss";

import { useEffect, useState } from "react";

import { LoadingOverlay } from "../../components/LoadingOverlay/LoadingOverlay";
import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { useBilling } from "../../hooks/reactQueryHooks/useBilling";
import { AutoRecharge } from "./components/AutoRecharge";
import { BadgesController } from "./components/Badges";
import { BillingAlert } from "./components/BillingAlert";
import { Links } from "./components/Links";
import { LowBallanceAlert } from "./components/LowBallanceAlert";
import { SubscriptionInfo } from "./components/SubscriptionInfo";

const billingBreadcrumbs = [
  {
    title: "Organization",
    path: "",
    isSeparator: false,
    isActive: true,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const BillingWrapper = () => {
  const [lowBallanceThreshhold, setLowBallanceThreshhold] = useState(0);
  const { currentOrganization, accessAllowed, setAccessAllowed } =
    useOrganizationContext();
  const { data, isFetching, isError, error } = useBilling(
    currentOrganization?.id,
  );

  const isStripe = data?.provider === "stripe";

  useEffect(() => {
    if (
      isError &&
      error?.response?.data[0]?.code === "BillingMetricsNotFound"
    ) {
      setAccessAllowed(false);
    }
  }, [isError, setAccessAllowed, error?.response?.data]);

  const accountBallance =
    data?.ptuBillingInfo?.credits || data?.ptuBillingInfo?.amountDue || 0;

  return (
    <>
      <PageTitle
        breadcrumbs={billingBreadcrumbs}
        breadcrumbTitle="Billing"
        pageTitle="Billing"
      />

      {accessAllowed && data && <BadgesController data={data} />}

      <div className="card flex-shrink-1 flex-grow-1">
        <div className="app-container-inner-wrapper">
          {!isFetching && !accessAllowed ? (
            <BillingAlert orgName={currentOrganization?.name || ""} />
          ) : (
            <>
              {data && accountBallance <= lowBallanceThreshhold && isStripe && (
                <LowBallanceAlert outOfCredits={accountBallance <= 0} />
              )}

              <SubscriptionInfo
                subscriptionType={data?.type || ""}
                isStripe={isStripe}
                organization={currentOrganization?.id || ""}
              />

              {isStripe && (
                <>
                  <div className="divider" />
                  <AutoRecharge
                    organization={currentOrganization?.id || ""}
                    accBallance={accountBallance}
                    setLowBallanceThreshhold={setLowBallanceThreshhold}
                  />
                </>
              )}

              <div className="divider" />

              <Links
                isStripe={isStripe}
                organization={currentOrganization?.id || ""}
              />
            </>
          )}

          {(isFetching || !data) && !isError && <LoadingOverlay />}
        </div>
      </div>
    </>
  );
};

export { BillingWrapper };
